import React from "react"

function Megaphone({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5323 12.3652H7.59885V19.7744H10.5323V12.3652Z"
        stroke="#003E4C"
        strokeWidth="1.00047"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5206 12.3653H16.8187C16.8187 12.3653 25.1705 9.59893 27.69 8.76475C27.8554 8.71023 28.0365 8.73779 28.1772 8.83978C28.3179 8.9412 28.4011 9.10475 28.4011 9.27828C28.4011 11.8553 28.4011 20.3396 28.4011 22.9236C28.4011 23.0977 28.3173 23.2613 28.176 23.3627C28.0342 23.4647 27.8524 23.4916 27.6877 23.436C25.1664 22.5853 16.8304 19.7739 16.8304 19.7739H12.5206"
        stroke="#003E4C"
        strokeWidth="1.00047"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6094 12.4004V19.7339"
        stroke="#003E4C"
        strokeWidth="1.00047"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6851 14.5004L25.7155 12.3232"
        stroke="#003E4C"
        strokeWidth="1.00047"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2858 21.6968V25.2147C10.2858 25.5898 10.3948 25.9574 10.5994 26.2722C11.4242 27.5425 13.1406 27.5261 14.0182 26.594C14.3388 26.2581 14.5182 25.8108 14.5182 25.3466C14.5235 24.5991 14.5235 22.3158 14.5235 22.3158H16.3068"
        stroke="#003E4C"
        strokeWidth="1.00047"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Megaphone
